/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/audit-reports-api-client";
import type { UpdateReportDefinitionMutationRequest, UpdateReportDefinitionMutationResponse, UpdateReportDefinitionPathParams, UpdateReportDefinition400, UpdateReportDefinition404 } from "../models/UpdateReportDefinition";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { updateReportDefinition } from "../axios/updateReportDefinition";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const updateReportDefinitionMutationKey = () => ["audit-reports-api", { url: '/report-definitions/:id' }] as const

export type UpdateReportDefinitionMutationKey = ReturnType<typeof updateReportDefinitionMutationKey>

export function updateReportDefinitionMutationOptions<TContext = unknown>(config: Partial<RequestConfig<UpdateReportDefinitionMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = updateReportDefinitionMutationKey()
        return mutationOptions<UpdateReportDefinitionMutationResponse, ResponseErrorConfig<UpdateReportDefinition400 | UpdateReportDefinition404>, {id: UpdateReportDefinitionPathParams["id"], data: UpdateReportDefinitionMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ id, data }) => {
            return updateReportDefinition(id, data, config)
          },
        })

}

/**
 * @description Updates the report definition by its unique identifier. The definition must match the blueprint version of the existing entity. If isDefault is set to true, this definition will be set as the default for its report type and other defaults will be unset.
 * @summary Update report definition
 * {@link /report-definitions/:id}
 */
export function useUpdateReportDefinition<TContext>(options: 
{
  mutation?: UseMutationOptions<UpdateReportDefinitionMutationResponse, ResponseErrorConfig<UpdateReportDefinition400 | UpdateReportDefinition404>, {id: UpdateReportDefinitionPathParams["id"], data: UpdateReportDefinitionMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<UpdateReportDefinitionMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? updateReportDefinitionMutationKey()

          const baseOptions = updateReportDefinitionMutationOptions(config) as UseMutationOptions<UpdateReportDefinitionMutationResponse, ResponseErrorConfig<UpdateReportDefinition400 | UpdateReportDefinition404>, {id: UpdateReportDefinitionPathParams["id"], data: UpdateReportDefinitionMutationRequest}, TContext>
          

          return useMutation<UpdateReportDefinitionMutationResponse, ResponseErrorConfig<UpdateReportDefinition400 | UpdateReportDefinition404>, {id: UpdateReportDefinitionPathParams["id"], data: UpdateReportDefinitionMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<UpdateReportDefinitionMutationResponse, ResponseErrorConfig<UpdateReportDefinition400 | UpdateReportDefinition404>, {id: UpdateReportDefinitionPathParams["id"], data: UpdateReportDefinitionMutationRequest}, TContext>
      
}